export default __webpack_public_path__ + "static/media/33.f139291a.svg";